module.exports = __webpack_public_path__ + "img/faemg_branco.7568f3ac.png";